import { render } from "./SaveEmployeeReport.vue?vue&type=template&id=53049f02&scoped=true"
import script from "./SaveEmployeeReport.vue?vue&type=script&lang=js"
export * from "./SaveEmployeeReport.vue?vue&type=script&lang=js"

import "./employee-report.scss?vue&type=style&index=0&id=53049f02&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53049f02"]])

export default __exports__